'use strict';

var CalendarEventParser = require('../../db/util/CalendarEventParser');
var CallFieldsExtension = require('./CallFieldsExtension');
require('./CallsService');
var defaults = require('../../defaults/Defaults');
require('./KayleeService');
var log = require('../../log/Log').channel('CalendarController');
var moment = require('moment-timezone');
require('./RoomService');
var sutl = require('../../sutl/Sutl');
var TooltipExtension = require('./TooltipExtension').default;
var objectToArray = require('./ObjectToArray');

angular.module('inara').controller('CalendarController', CalendarController);

angular.module('inara').filter('discardOldEvents', function () {
    return function (events) {
        var filteredEvents = [];
        var now = Date.now();

        if (typeof events === 'undefined' || events === null || !Array.isArray(events)) {
            return events;
        }

        for (var i = 0; i < events.length; i++) {
            if (events[i].end > now) {
                filteredEvents.push(events[i]);
            }
        }

        return filteredEvents;
    };
});

CalendarController.$inject = [
    '$scope',
    '$state',
    '$timeout',
    '$ionicPopover',
    '$ionicScrollDelegate',
    'ionicMaterialInk',
    'CallsService',
    'RoomService',
    'KayleeService',
    'orderByFilter',
    '$ionicPopup',
    '$ionicViewSwitcher',
    '$location',
    'gettextCatalog',
];

function CalendarController(
    $scope,
    $state,
    $timeout,
    $ionicPopover,
    $ionicScrollDelegate,
    ionicMaterialInk,
    CallsService,
    RoomService,
    KayleeService,
    orderByFilter,
    $ionicPopup,
    $ionicViewSwitcher,
    $location,
    gettextCatalog
) {
    var vm = this;
    var room = null;
    var company = null;
    var calendar = null;
    var timeBeforeDialAllowed = moment.duration(defaults.inara.calendarTimeBeforeDialAllowedMs);
    var dateFormat = 'LL';
    var showMoreOptions = false;
    var showDetails = false;
    var futurePlaceCallTouched = false;
    var futurePlaceCallPopover = null;
    var nextEventTimeout = null;
    var urlCalendarEventId = null;
    var calendarConfigured = false;
    /// Placeholder when no contact numbers could be parsed from a calendar meeting invitation
    var noCompatibleNumbersLabel = gettextCatalog.getString('No contact numbers found');
    var previousCalendarInfo = null;
    var lastCallMethod = null;
    var lastCallMethodTimeout = null;

    log.info('initializing');

    angular.extend(vm, new CallFieldsExtension());
    angular.extend(vm, new TooltipExtension($scope, $ionicPopover));

    ionicMaterialInk.displayEffect({ duration: defaults.inara.inkDuration });

    vm.events = null;
    vm.eventsLoaded = function () {
        return calendar && calendar.$isLoaded();
    };
    vm.getEvents = function () {
        return vm.events;
    };
    vm.getRoomName = function () {
        return room.name;
    };
    vm.nextEvent = null;
    vm.selectedEvent = null;
    vm.isUpcomingEvent = isUpcomingEvent;
    vm.bestCallMethod = bestCallMethod;
    vm.canCall = canCall;
    vm.placeCall = placeCall;
    vm.getDate = getDate;
    vm.getTime = getTime;
    vm.getDuration = getDuration;
    vm.onNoContactNumber = onNoContactNumber;
    vm.onShowMoreOptions = onShowMoreOptions;
    vm.isShowingMoreOptions = isShowingMoreOptions;
    vm.isFuturePlaceCallTouched = isFuturePlaceCallTouched;
    vm.onShowDetails = onShowDetails;
    vm.isShowingDetails = isShowingDetails;
    vm.onDialManually = onDialManually;
    vm.resetViewState = resetViewState;
    vm.getNumberLabel = getNumberLabel;
    vm.getMeetingCodesLabel = getMeetingCodesLabel;
    vm.getNumberIcon = getNumberIcon;
    vm.getNumberCount = getNumberCount;
    vm.getCallMethods = getCallMethods;
    vm.onSelectEvent = onSelectEvent;
    vm.getAllDayMsg = getAllDayMsg;
    vm.getNoEventsMsg = getNoEventsMsg;
    vm.hasConfiguredCallCaps = function () {
        return (
            CallsService.hasConfiguredCallCapsClass('audio') ||
            CallsService.hasConfiguredCallCapsClass('video')
        );
    };

    $scope.$on('$stateChangeSuccess', onStateChange);
    $scope.$on('$ionicView.beforeEnter', onViewBeforeEnter);
    $scope.$on('$ionicView.enter', onViewEnter);
    $scope.$on('$destroy', function () {
        RoomService.offOnlineChanged(onRoomOnlineChanged);
        removeCallbacks();
    });
    $scope.$on('IdleTimeout', function () {
        resetViewState();
    });
    $scope.$on('popover.hidden', function (event, popover) {
        if (popover === futurePlaceCallPopover) {
            futurePlaceCallPopover = null;
            futurePlaceCallTouched = true;
        }
    });

    RoomService.onOnlineChanged(onRoomOnlineChanged);

    function getCalendarFormat() {
        return {
            /// Calendar placeholder for today's date
            sameDay: '[' + gettextCatalog.getString('Today') + ']',
            /// Calendar placeholder for tomorrow's date
            nextDay: '[' + gettextCatalog.getString('Tomorrow') + ']',
            nextWeek: dateFormat,
            lastDay: dateFormat,
            lastWeek: dateFormat,
            sameElse: dateFormat,
        };
    }

    function removeCallbacks() {
        if (room !== null) {
            room.$offChange(onRoomChanged);
            room = null;
        }
        if (company !== null) {
            company.$offChange(onCompanyChanged);
            company = null;
        }
        if (calendar !== null) {
            calendar.$offChange(onCalendarChanged);
            calendar = null;
        }
        if (nextEventTimeout !== null) {
            $timeout.cancel(nextEventTimeout);
            nextEventTimeout = null;
        }
    }

    function onViewBeforeEnter() {
        // Don't reset selected event if we're going to set it anyway in
        // onViewEnter...
        resetViewState(urlCalendarEventId === null, false);
    }

    function onViewEnter() {
        // Track whether view is active so we can set an id on each future calendar
        // event. This is needed because we may cache other calendar views with
        // different URL parameters, and we don't want to anchor scroll to those
        // items when the view is inactive.
        vm.viewActive = true;
        $timeout(function () {
            if (urlCalendarEventId !== null) {
                $ionicScrollDelegate.$getByHandle('calendar-events-scroll').anchorScroll(true);
                getNextEvent();
            } else {
                $ionicScrollDelegate.$getByHandle('calendar-events-scroll').scrollTop(true);
            }
        }, 1);
    }

    function onStateChange(event, toState, toParams, fromState, fromParams) {
        if (toState.name === 'control.calendar') {
            urlCalendarEventId = angular.isDefined(toParams.calendarEventId)
                ? toParams.calendarEventId
                : null;
            if (urlCalendarEventId) {
                $location.hash(urlCalendarEventId);
            }
        } else {
            // Track whether view is active so we can set an id on each future calendar
            // event. This is needed because we may cache other calendar views with
            // different URL parameters, and we don't want to anchor scroll to those
            // items when the view is inactive.
            vm.viewActive = false;
            vm.tooltip.hide();
        }
    }

    function onRoomOnlineChanged(online) {
        // NOTE: this used to be hooked up to onBeforeOnlineChanged, but since
        // that fires before RoomService.online() changes, the updateCalendarInfo()
        // call could end up reporting that RoomService.online() was false and
        // thus empty the list of events. Since other code in the controller
        // depends on RoomService.online() checks, it made sense to hook up to
        // onRoomOnlineChanged.
        if (online) {
            room = RoomService.getRoom();
            room.$onChange(onRoomChanged);
            company = KayleeService.getCompany(room.companyId);
            company.$onChange(onCompanyChanged);
            calendar = room.$getCalendar();
            calendar.$onChange(onCalendarChanged);
        } else {
            removeCallbacks();
        }
        updateCalendarInfo();
    }

    function updateCalendarInfo(isCalendarUpdate) {
        if (!angular.isDefined(isCalendarUpdate)) {
            isCalendarUpdate = false;
        }

        calendarConfigured =
            RoomService.online() &&
            room !== null &&
            company !== null &&
            calendar !== null &&
            sutl.getNode(room, 'caps.hasCalendar', false);

        if (
            calendarConfigured &&
            (previousCalendarInfo === null ||
                sutl.getNode(previousCalendarInfo, 'type') !==
                    sutl.getNode(room, 'settings.calendarSource.type') ||
                sutl.getNode(previousCalendarInfo, 'id') !==
                    sutl.getNode(room, 'settings.calendarSource.id') ||
                isCalendarUpdate)
        ) {
            previousCalendarInfo = angular.copy(room.settings.calendarSource);

            var eventsArray = objectToArray(angular.copy(calendar.events));

            for (var i = 0; i < eventsArray.length; i++) {
                var event = eventsArray[i];
                var callMethods = reduceCallMethods(CalendarEventParser.getCallMethods(event));

                if (Object.keys(callMethods).length > 0) {
                    event.callMethods = callMethods;
                }
            }

            vm.events = orderByFilter(eventsArray, getEventCompareValue);
            getNextEvent();
        } else if (!calendarConfigured && vm.events !== null) {
            previousCalendarInfo = null;
            vm.events = null;
            getNextEvent();
        }
    }

    function onCompanyChanged() {
        updateCalendarInfo();
    }

    function onCalendarChanged() {
        updateCalendarInfo(true);
    }

    function onRoomChanged() {
        updateCalendarInfo();
    }

    function getNextEvent() {
        if (room === null || vm.events === null || vm.events.length === 0) {
            vm.nextEvent = null;
            return;
        }

        var now = Date.now();
        var nextEvent = null;
        if (nextEventTimeout !== null) {
            $timeout.cancel(nextEventTimeout);
            nextEventTimeout = null;
        }

        // Check for a URL event
        if (urlCalendarEventId !== null) {
            nextEvent =
                vm.events.find(function (event) {
                    return event.$id === urlCalendarEventId;
                }) || null;
        }

        // No URL event, check for user selected event
        if (nextEvent === null && vm.selectedEvent !== null && vm.selectedEvent.end > now) {
            nextEvent =
                vm.events.find(function (event) {
                    return vm.selectedEvent.$id === event.$id;
                }) || null;
        }

        // No user selected event, get the next event in time
        if (nextEvent === null) {
            nextEvent =
                vm.events.find(function (event) {
                    return event.end > now && (nextEvent === null || event.start < nextEvent.start);
                }) || null;
        }

        if (urlCalendarEventId !== null) {
            urlCalendarEventId = null;
        }

        vm.nextEvent = nextEvent;
        vm.selectedEvent = nextEvent;

        if (vm.nextEvent === null) {
            // If there is no next event, check again in a day
            nextEventTimeout = $timeout(getNextEvent, 1000 * 60 * 60 * 24);
        } else {
            var timeUntilNextEventEnd = vm.nextEvent.end - now;
            // If no other state changes trigger getNextEvent, we should call it
            // again when the nextEvent ends
            if (timeUntilNextEventEnd > 0) {
                nextEventTimeout = $timeout(getNextEvent, timeUntilNextEventEnd);
            }
        }
    }

    function getEventCompareValue(event) {
        return event.isAllDay ? event.end : event.start;
    }

    // The "upcoming" event is the subsequent event where "now" is between
    // the start of the event minus timeBeforeDialAllowed and the end of the
    // event.

    function isUpcomingEvent(calendarEvent) {
        if (typeof calendarEvent === 'undefined' || calendarEvent === null) return false;
        var eventStart = moment(calendarEvent.start);
        var eventEnd = moment(calendarEvent.end);
        return moment().isBetween(eventStart.subtract(timeBeforeDialAllowed), eventEnd);
    }

    function bestCallMethod(calendarEvent) {
        if (!RoomService.online()) return null;

        if (
            typeof calendarEvent === 'undefined' ||
            calendarEvent === null ||
            !calendarEvent.hasOwnProperty('callMethods')
        )
            return null;

        var callMethodKeys = Object.keys(calendarEvent.callMethods).sort();
        var bestCallMethod = null;
        var bestCallTypeIndex = KayleeService.callTypes.length;
        var index;

        for (var i = 0; i < callMethodKeys.length; i++) {
            var callMethod = calendarEvent.callMethods[callMethodKeys[i]];

            if (
                sutl.getNode(callMethod, 'callTypeDetail.zoomConnector', false) &&
                !sutl.getNode(room, 'caps.hasZoomConnector', false)
            )
                continue;

            if (callMethod.hasOwnProperty('callType')) {
                if (CallsService.canCallType(callMethod.callType)) {
                    index = KayleeService.callTypes.indexOf(callMethod.callType);
                    if (index < bestCallTypeIndex) {
                        bestCallMethod = callMethod;
                        bestCallTypeIndex = index;
                    }
                }
            } else {
                var callType = CallsService.getBestAvailableCallTypeByClass(callMethod.callClass);

                if (callType !== null) {
                    index = KayleeService.callTypes.indexOf(callType);
                    if (index < bestCallTypeIndex) {
                        bestCallMethod = callMethod;
                        bestCallTypeIndex = index;
                    }
                }
            }
        }

        // Return the last call method used to place a call to avoid button
        // state flipping to show alternative call method after placing a
        // call. lastCallMethod is reset to null after a short timeout.

        if (lastCallMethod !== null) return lastCallMethod;

        if (bestCallMethod !== null) return bestCallMethod;

        // return even an unsupported method and we'll show it as unavailable

        if (callMethodKeys.length > 0) {
            return calendarEvent.callMethods[callMethodKeys[0]];
        }

        return null;
    }

    function canCall(callMethod) {
        if (callMethod === null) return false;
        if (!RoomService.online()) return false;
        if (callMethod.hasOwnProperty('callType')) {
            return CallsService.canCallType(callMethod.callType);
        }
        return CallsService.canCallClass(callMethod.callClass);
    }

    function placeCall(callMethod, calendarEvent, $event) {
        var cm;
        /// Tooltip when user presses place call button for a meeting in the future.
        var futureMeetingTooltip = gettextCatalog.getString(
            'This meeting occurs in the future.  After closing this ' +
                'message, please touch this button to call now.'
        );

        if (!RoomService.online()) return;

        if (callMethod === null) {
            log.error(
                'call method was null for calendar event: ' + JSON.stringify(calendarEvent, null, 4)
            );
            return;
        }

        if (callMethod.hasOwnProperty('callType')) {
            if (!CallsService.hasConfiguredCallCapsType(callMethod.callType)) {
                vm.tooltip.show(
                    CallsService.getUnsupportedCallTypeString(callMethod.callType),
                    $event
                );
                return;
            }

            if (!CallsService.canCallType(callMethod.callType)) {
                vm.tooltip.show(
                    CallsService.getExceededMaxCallsStringByType(callMethod.callType),
                    $event
                );
                return;
            }

            if (!isUpcomingEvent(calendarEvent) && !futurePlaceCallTouched) {
                $timeout(function () {
                    vm.tooltip.show(futureMeetingTooltip, $event).then(function (popover) {
                        futurePlaceCallPopover = popover;
                    });
                }, 1);
                return;
            }

            if (CallsService.canCallType(callMethod.callType)) {
                setLastCallMethodTimeout(callMethod);
                cm = angular.extend(callMethod, { calendarEventId: calendarEvent.$id });
                $ionicViewSwitcher.nextDirection('forward');
                CallsService.placeCallByType(cm);
                return;
            }
        } else {
            // no callType, dial by callClass instead
            if (!CallsService.hasConfiguredCallCapsClass(callMethod.callClass)) {
                vm.tooltip.show(
                    CallsService.getUnsupportedCallClassString(callMethod.callClass),
                    $event
                );
                return;
            }

            if (!CallsService.canCallClass(callMethod.callClass)) {
                vm.tooltip.show(
                    CallsService.getExceededMaxCallsStringByClass(callMethod.callClass),
                    $event
                );
                return;
            }

            if (!isUpcomingEvent(calendarEvent) && !futurePlaceCallTouched) {
                $timeout(function () {
                    vm.tooltip.show(futureMeetingTooltip, $event).then(function (popover) {
                        futurePlaceCallPopover = popover;
                    });
                }, 1);
                return;
            }

            if (CallsService.canCallClass(callMethod.callClass)) {
                setLastCallMethodTimeout(callMethod);
                cm = angular.extend(callMethod, { calendarEventId: calendarEvent.$id });
                $ionicViewSwitcher.nextDirection('forward');
                CallsService.placeCallByClass(cm);
                return;
            }
        }

        log.error(
            "can't place " +
                callMethod.callClass +
                ' call for calendar event: ' +
                JSON.stringify(calendarEvent, null, 4)
        );
    }

    function setLastCallMethodTimeout(callMethod) {
        if (lastCallMethodTimeout !== null) $timeout.cancel(lastCallMethodTimeout);
        lastCallMethod = callMethod;
        lastCallMethodTimeout = $timeout(function () {
            lastCallMethod = null;
            lastCallMethodTimeout = null;
        }, 500);
    }

    function getDate(dateTime) {
        if (!RoomService.online() || room === null || dateTime === null) return '';

        var site = KayleeService.getSite(room.siteId);
        if (site.$isLoaded()) {
            return moment(dateTime).tz(site.settings.timeZone).calendar(null, getCalendarFormat());
        }
        return '';
    }

    function getTime(dateTime) {
        if (
            !RoomService.online() ||
            room === null ||
            typeof dateTime === 'undefined' ||
            dateTime === null
        ) {
            return '';
        }

        var site = KayleeService.getSite(room.siteId);
        if (site.$isLoaded()) {
            return moment(dateTime).tz(site.settings.timeZone).format(site.settings.timeFormat);
        }
        return '';
    }

    function getDuration(calendarEvent) {
        return moment(calendarEvent.end).to(moment(calendarEvent.start), true);
    }

    function onNoContactNumber($event) {
        /// Tooltip displayed trying to place call from a calendar meeting with no contact numbers
        vm.tooltip.show(
            gettextCatalog.getString(
                'No contact numbers could be found in this meeting invitation.'
            ),
            $event
        );
    }

    function onShowMoreOptions(show) {
        showMoreOptions = !!show;
    }

    function isShowingMoreOptions() {
        return showMoreOptions;
    }

    function onShowDetails(show) {
        showDetails = !!show;
    }

    function isShowingDetails() {
        return showDetails;
    }

    function isFuturePlaceCallTouched(calendarEvent, callClass) {
        return futurePlaceCallTouched;
    }

    function onDialManually(calendarEvent) {
        $state.go('control.dialpad', { calendarEventId: calendarEvent.$id });
    }

    function resetViewState(resetSelectedEvent, resetScroll) {
        if (!angular.isDefined(resetSelectedEvent)) {
            resetSelectedEvent = true;
        }
        if (!angular.isDefined(resetScroll)) {
            resetScroll = true;
        }
        futurePlaceCallTouched = false;
        showMoreOptions = false;
        showDetails = false;
        vm.tooltip.hide();
        if (resetSelectedEvent) {
            if (resetScroll && vm.viewActive) {
                $ionicScrollDelegate.$getByHandle('calendar-events-scroll').scrollTop(true);
            }
            vm.selectedEvent = null;
            getNextEvent();
        }
    }

    function getNumberLabel(callMethod) {
        if (callMethod !== null) {
            var dialString = angular.isDefined(callMethod.displayDialString)
                ? callMethod.displayDialString
                : callMethod.dialString;
            dialString = dialString.split(',')[0]; // throw away any meeting codes
            if (callMethod.callType === 'zoom') {
                /// Label for Zoom dial string parsed from calendar event invitation
                return gettextCatalog.getString('Zoom: {{dialString}}', { dialString: dialString });
            } else if (callMethod.callType === 'teams') {
                /// Label for Teams dial string parsed from calendar event invitation
                return gettextCatalog.getString('Teams: {{dialString}}', {
                    dialString: dialString,
                });
            } else if (callMethod.callClass === 'video') {
                /// Label for video dial string parsed from calendar event invitation
                return gettextCatalog.getString('Video: {{dialString}}', {
                    dialString: dialString,
                });
            } else {
                /// Label for audio dial string parsed from calendar event invitation
                return gettextCatalog.getString('Audio: {{dialString}}', {
                    dialString: dialString,
                });
            }
        }

        return noCompatibleNumbersLabel;
    }

    function getMeetingCodesLabel(callMethod) {
        if (callMethod === null || !callMethod.hasOwnProperty('meetingCodes')) return '';

        /// Label for meeting codes parsed from calendar event invitation
        return gettextCatalog.getString('Meeting codes: {{meetingCodes}}', {
            meetingCodes: vm.callfields.getMeetingCodes(callMethod),
        });
    }

    function getNumberIcon(callMethod) {
        if (callMethod === null) return 'ion-android-call';

        switch (callMethod.callClass) {
            case 'video':
                return 'ion-aveo-video';
            case 'audio':
                return 'ion-android-call';
            default:
                return 'ion-android-call';
        }
    }

    function getNumberCount(calendarEvent) {
        return calendarEvent !== null && calendarEvent.hasOwnProperty('callMethods')
            ? Object.keys(calendarEvent.callMethods).length
            : 0;
    }

    function getCallMethods(calendarEvent) {
        if (calendarEvent === null || !calendarEvent.hasOwnProperty('callMethods')) return [];
        if (!RoomService.online()) return [];

        var callMethods = [];
        var callMethodKeys = Object.keys(calendarEvent.callMethods).sort();

        for (var i = 0; i < callMethodKeys.length; i++) {
            var callMethod = calendarEvent.callMethods[callMethodKeys[i]];
            if (
                sutl.getNode(callMethod, 'callTypeDetail.zoomConnector', false) &&
                !sutl.getNode(room, 'caps.hasZoomConnector', false)
            )
                continue;

            callMethods.push(callMethod);
        }

        return callMethods;
    }

    function onSelectEvent(calendarEvent) {
        futurePlaceCallTouched = false;
        showMoreOptions = false;
        showDetails = false;
        vm.selectedEvent = calendarEvent;
        getNextEvent();
    }

    function getAllDayMsg() {
        /// Calendar event duration label for all day meeting
        return gettextCatalog.getString('All day');
    }

    function getNoEventsMsg() {
        if (
            RoomService.online() &&
            calendar !== null &&
            angular.isDefined(calendar.eventWindowDays) &&
            calendar.eventWindowDays <= 1
        ) {
            /// Placeholder text when no meetings are in the calendar for the next duration of a day
            return gettextCatalog.getString('No meetings today');
        }
        /// Placeholder text when no meetings are in the calendar for the next duration longer than one day
        return gettextCatalog.getString('No meetings in the near future');
    }

    function reduceCallMethods(callMethods) {
        // Convert callType to callClass.

        for (var id in callMethods) {
            if (!callMethods.hasOwnProperty(id)) continue;
            var callMethod = callMethods[id];
            callMethod.callClass = KayleeService.getCallClass(callMethod.callType);
        }

        // Identify duplicates.

        var ids = Object.keys(callMethods).sort();
        var remove = [];
        var i, j;

        for (i = 0; i < ids.length; i++) {
            if (remove.includes[ids[i]]) continue;
            var a = callMethods[ids[i]];
            var removedDuplicates = false;

            // Only remove duplicates for the audio class.
            if (a.callClass !== 'audio') continue;

            for (j = i + 1; j < ids.length; j++) {
                if (remove.includes[ids[j]]) continue;
                var b = callMethods[ids[j]];

                if (
                    a.callClass === b.callClass &&
                    a.dialString === b.dialString &&
                    sutl.objEquals(a.meetingCodes, b.meetingCodes)
                ) {
                    remove.push(ids[j]);
                    removedDuplicates = true;
                }
            }

            if (removedDuplicates) {
                delete a.callType;
            }
        }

        // Remove duplicates.

        if (remove.length === 0) return callMethods;
        var newCallMethods = {};
        j = 0;

        for (i = 0; i < ids.length; i++) {
            if (remove.includes(ids[i])) continue;
            newCallMethods['a' + j] = callMethods[ids[i]];
            j++;
        }

        return newCallMethods;
    }
}

module.exports = CalendarController;
